import { BRAND_LOGO_SRC, BRAND_LOGO_BLUE } from "@/lib/brand";

/** Matches mobile `AppLogo` — square logo with ~12% corner radius on brand blue. */
const SIZES = {
  xs: 36,
  sm: 44,
  md: 56,
  lg: 72,
  xl: 96,
};

/**
 * @param {{ size?: keyof typeof SIZES | number, className?: string, alt?: string, testId?: string }} props
 */
export default function BrandLogo({
  size = "md",
  className = "",
  alt = "CoinMBX",
  testId,
}) {
  const dim = typeof size === "number" ? size : SIZES[size] ?? SIZES.md;
  const radius = Math.round(dim * 0.12);

  return (
    <span
      data-testid={testId}
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden ${className}`}
      style={{
        width: dim,
        height: dim,
        borderRadius: radius,
        backgroundColor: BRAND_LOGO_BLUE,
      }}
    >
      <img
        src={BRAND_LOGO_SRC}
        alt={alt}
        width={dim}
        height={dim}
        className="block h-full w-full object-contain"
        style={{ borderRadius: radius }}
        draggable={false}
      />
    </span>
  );
}
